import React from 'react';
import Route from 'found/lib/Route';
import OpenWorkspaceContainer from '../components/Share/OpenWorkspaceContainer';
import OpenEstimateContainer from '../components/Share/OpenEstimateContainer';
import OpenInvoiceContainer from '../components/Share/OpenInvoiceContainer';
import OpenFormContainer from '../components/Share/OpenFormContainer';
import OpenMusicPlannerContainer from '../components/Share/OpenMusicPlannerContainer';
import OpenContractContainer from '../components/Share/OpenContractContainer';
import OpenSignContractContainer from '../components/Share/OpenSignContractContainer';
import { graphql } from 'react-relay';

const ShareRoutes = (
  <Route path='open'>
    <Route
      path='w/:share_token'
      Component={OpenWorkspaceContainer}
      query={graphql`
        query ShareRoutes_OpenWorkspace_Query {
          viewer {
            ...OpenWorkspaceContainer_viewer
          }
        }
      `}
    />
    <Route
      path='e/:share_token'
      Component={OpenEstimateContainer}
      query={graphql`
        query ShareRoutes_OpenEstimate_Query {
          viewer {
            ...OpenEstimateContainer_viewer
          }
        }
      `}
    />
    <Route
      path='i/:share_token'
      Component={OpenInvoiceContainer}
      query={graphql`
        query ShareRoutes_OpenInvoice_Query {
          viewer {
            ...OpenInvoiceContainer_viewer
          }
        }
      `}
    />
    <Route
      path='f/:share_token'
      Component={OpenFormContainer}
      query={graphql`
        query ShareRoutes_OpenForm_Query {
          viewer {
            ...OpenFormContainer_viewer
          }
        }
      `}
    />
    <Route
      path='m/:share_token'
      Component={OpenMusicPlannerContainer}
      query={graphql`
        query ShareRoutes_OpenMusicPlanner_Query {
          viewer {
            ...OpenMusicPlannerContainer_viewer
          }
        }
      `}
    />
    <Route
      path='c/:share_token'
      Component={OpenContractContainer}
      query={graphql`
        query ShareRoutes_OpenContract_Query {
          viewer {
            ...OpenContractContainer_viewer
          }
        }
      `}
    />
    <Route
      path='sign/:share_token'
      Component={OpenSignContractContainer}
      query={graphql`
        query ShareRoutes_Sign_Query {
          viewer {
            ...OpenSignContractContainer_viewer
          }
        }
      `}
    />
  </Route>
);

export default ShareRoutes;



// WEBPACK FOOTER //
// ./webpack/routes/ShareRoutes.js